// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1861":"e5701681","6583":"e5701681","8055":"2b5ded0b"}[chunkId] + ".chunk.css";
};